<ds-form-field style="width: 100px">
  <ds-select
    id="currentUserLanguage"
    [labellingConfig]="{
      placeholder: translateService.instant('dashboard.header.language'),
    }"
    [ngModel]="currentUserActiveLanguage()"
    [options]="languageOptions() | selectListSort"
    [size]="size()"
    (valueChange)="onCurrentUserLanguageChange($event)"
  >
  </ds-select>
</ds-form-field>
